import React from "react";
import "./ConfirmModal.css";
import { MdOutlineQuestionMark } from "react-icons/md";

const ConfirmationModal = ({ onResolve }) => {
  const handleConfirm = () => {
    onResolve(true);
  };

  const handleReject = () => {
    onResolve(false);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-confirm">
        <div className="modal-content">
          <div className="modal-header">
            <div className="icon-box">
              <span className="material-icons"><MdOutlineQuestionMark /></span>
            </div>
            <h4>Are you sure?</h4>
          </div>
          <div className="modal-body">
            <p>
              Do you really want to perform the action?
            </p>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-danger"
              onClick={handleConfirm}
            >
              Yes
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={handleReject}
            >
              No
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
